export const getAncestorElement = (element, ancestorClass) => {
    if (element) {
        while ((element = element.parentElement) && !element.classList.contains(ancestorClass));
    }
    return element;
};
